export const PERSONALIZATION_BEACON_CONFIGS = {
  ADD_VARIANT_MANUAL: 'personalization-create-manually',
  ADD_VARIANT_AI: 'personalization-create-with-ai',
  VARIANT_SELECT: 'personalization-variant-select'
};